import * as React from "react";
import type { SVGProps } from "react";
const SvgIcSupport = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 22 18"
    {...props}
  >
    <path
      fill="#040747"
      fillRule="evenodd"
      d="m12.302 13.239 2.278 2.134c.005.004.032.024.087.024s.082-.02.086-.024l2.279-2.134h.801c.875 0 1.584-.718 1.584-1.603v-7.43c0-.886-.71-1.603-1.584-1.603H5.167c-.875 0-1.584.717-1.584 1.602v7.431c0 .885.71 1.603 1.584 1.603zM2 4.205C2 2.435 3.418 1 5.167 1h12.666C19.583 1 21 2.435 21 4.205v7.431c0 1.77-1.418 3.205-3.167 3.205h-.181l-1.823 1.708a1.723 1.723 0 0 1-2.325 0l-1.823-1.708H5.167C3.417 14.841 2 13.406 2 11.636z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIcSupport;
